import styled from "styled-components";

import RaffleItem from "components/RaffleItem";
import { raffleDefaults } from "helpers/functions";

const RaffleHome = ({
  loading,
  setLoading,
}: {
  loading: Boolean;
  setLoading: Function;
}) => {
  return (
    <div>
      <Container>
        {raffleDefaults
          .sort((a, b) => (a.startDate < b.startDate ? 1 : -1))
          .map((raffle) => (
            <RaffleItem raffle={raffle} key={raffle.raffleId} />
          ))}
      </Container>
    </div>
  );
};

export default RaffleHome;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 768px) {
    align-items: center;
    flex-direction: column;
  }
`;
